var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatBotHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_20706_15890)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.3608,
    cy: 19.8613,
    r: 17.6132,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.3608,
    cy: 19.8613,
    r: 14.1132,
    stroke: "#1F1414",
    strokeWidth: 7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_20706_15890)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.1108,
    cy: 17.6132,
    r: 17.6132,
    fill: "#084254"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.1108,
    cy: 17.6132,
    r: 14.1132,
    stroke: "black",
    strokeWidth: 7
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 28.9248C9.50222 28.9248 13.5443 20.5548 13.5443 16.4552C13.5443 24.6544 20.8617 28.9248 26.2627 28.9248C17.3424 28.9248 13.5443 36.4407 13.5443 41.2235C13.5443 33.0243 5.7041 28.9248 1 28.9248Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3916 16.507C30.5516 16.507 33.0047 11.4273 33.0047 8.93927C33.0047 13.9153 37.4456 16.507 40.7235 16.507C35.3097 16.507 33.0047 21.0684 33.0047 23.9711C33.0047 18.995 28.2465 16.507 25.3916 16.507Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5443 9.14189C16.7106 9.14189 18.2159 6.02479 18.2159 4.49805C18.2159 7.55153 20.941 9.14189 22.9524 9.14189C19.6304 9.14189 18.2159 11.9409 18.2159 13.7221C18.2159 10.6686 15.2961 9.14189 13.5443 9.14189Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 28.9248C9.50222 28.9248 13.5443 20.5548 13.5443 16.4552C13.5443 24.6544 20.8617 28.9248 26.2627 28.9248C17.3424 28.9248 13.5443 36.4407 13.5443 41.2235C13.5443 33.0243 5.7041 28.9248 1 28.9248Z",
    stroke: "#0063CD",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3916 16.507C30.5516 16.507 33.0047 11.4273 33.0047 8.93927C33.0047 13.9153 37.4456 16.507 40.7235 16.507C35.3097 16.507 33.0047 21.0684 33.0047 23.9711C33.0047 18.995 28.2465 16.507 25.3916 16.507Z",
    stroke: "#0063CD",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5443 9.14189C16.7106 9.14189 18.2159 6.02479 18.2159 4.49805C18.2159 7.55153 20.941 9.14189 22.9524 9.14189C19.6304 9.14189 18.2159 11.9409 18.2159 13.7221C18.2159 10.6686 15.2961 9.14189 13.5443 9.14189Z",
    stroke: "#0063CD",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 28.1748C10.2522 28.1748 14.2943 19.8048 14.2943 15.7052C14.2943 23.9044 21.6117 28.1748 27.0127 28.1748C18.0924 28.1748 14.2943 35.6907 14.2943 40.4735C14.2943 32.2743 6.4541 28.1748 1.75 28.1748Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1416 15.757C31.3016 15.757 33.7547 10.6773 33.7547 8.18927C33.7547 13.1653 38.1956 15.757 41.4735 15.757C36.0597 15.757 33.7547 20.3184 33.7547 23.2211C33.7547 18.245 28.9965 15.757 26.1416 15.757Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2943 8.39189C17.4606 8.39189 18.9659 5.27479 18.9659 3.74805C18.9659 6.80153 21.691 8.39189 23.7024 8.39189C20.3804 8.39189 18.9659 11.1909 18.9659 12.9721C18.9659 9.91863 16.0461 8.39189 14.2943 8.39189Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 28.1748C10.2522 28.1748 14.2943 19.8048 14.2943 15.7052C14.2943 23.9044 21.6117 28.1748 27.0127 28.1748C18.0924 28.1748 14.2943 35.6907 14.2943 40.4735C14.2943 32.2743 6.4541 28.1748 1.75 28.1748Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1416 15.757C31.3016 15.757 33.7547 10.6773 33.7547 8.18927C33.7547 13.1653 38.1956 15.757 41.4735 15.757C36.0597 15.757 33.7547 20.3184 33.7547 23.2211C33.7547 18.245 28.9965 15.757 26.1416 15.757Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2943 8.39189C17.4606 8.39189 18.9659 5.27479 18.9659 3.74805C18.9659 6.80153 21.691 8.39189 23.7024 8.39189C20.3804 8.39189 18.9659 11.1909 18.9659 12.9721C18.9659 9.91863 16.0461 8.39189 14.2943 8.39189Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_20706_15890",
    x: 0.747559,
    y: 2.24805,
    width: 43.2266,
    height: 43.2266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_20706_15890"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_20706_15890",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_20706_15890",
    x: 1.49756,
    y: 0,
    width: 43.2266,
    height: 43.2266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_20706_15890"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_20706_15890",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBotHeaderIcon);
export default __webpack_public_path__ + "static/media/chatBotHeaderIcon.8520c1e7ca87d6dc4eb888e59df8e155.svg";
export { ForwardRef as ReactComponent };